import { memo } from 'react';
import { Nav } from 'react-bootstrap';

const TabNavMedicineDefault = () => {
  return (
    <Nav
      variant="pills"
      className="custom-tab mt-2"
      style={{ justifyContent: 'space-between' }}
    >
      <Nav.Item>
        <Nav.Link eventKey="suggestions">Doses</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="similarMedicines">Alternate Brand</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="formatsAndType">Dosage Form</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="information">Brand Details</Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default memo(TabNavMedicineDefault);
